export enum ERROR_CODES {
  REGISTRATION_EMAIL_ALREADY_IN_USE = 1101,
}
